/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for editModeType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="editModeType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="RW"/&gt; &lt;enumeration value="RWPARTIAL"/&gt; &lt;enumeration value="RO"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class EditModeType extends Enum{

	/**
	 * All aspects of the object are editable except for those that are derived.
	 */
	static  RW = EditModeType.newLiteral("RW");

	/**
	 * Some aspects of the object are editable.
	 */
	static  RWPARTIAL = EditModeType.newLiteral("RWPARTIAL");

	/**
	 * The object is read-only.
	 */
	static  RO = EditModeType.newLiteral("RO");



	value() {
		return this.name();
	}

	static fromValue(v) {
		return EditModeType.valueOf(v);
	}

	getResourceId() {
		return (("EditModeType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/EditModeType.js